(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ace-main"]) return;
  try {
    
if(!customElements.get('ace-quantity')){
customElements.define('ace-quantity',class extends HTMLElement{
connectedCallback(){
if(this.abort)return;this.abort=new AbortController();const opts={signal:this.abort.signal},input=this.querySelector('input'),minus=this.querySelector('[data-quantity-step="-1"]');
const sync=()=>{let value=Number(input.value);input.value=String(Number.isFinite(value)?Math.max(1,Math.floor(value)):1);minus.disabled=Number(input.value)<=1;};
this.querySelectorAll('[data-quantity-step]').forEach(button=>button.addEventListener('click',()=>{sync();input.value=String(Math.max(1,Number(input.value)+Number(button.dataset.quantityStep)));sync();input.dispatchEvent(new Event('input',{bubbles:true}));input.dispatchEvent(new Event('change',{bubbles:true}));},opts));
input.addEventListener('change',sync,opts);sync();
}
disconnectedCallback(){this.abort?.abort();this.abort=null;}
});}

if(!customElements.get('ace-product-gallery')){
customElements.define('ace-product-gallery',class extends HTMLElement{
connectedCallback(){
if(this.ready)return;this.ready=true;this.index=0;this.slides=Array.from(this.querySelectorAll('.apg-slide'));this.abort=new AbortController();const opts={signal:this.abort.signal};
this.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>this.show(this.index+Number(button.dataset.step)),opts));
this.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.show(this.index+(e.key==='ArrowLeft'?1:-1));}},opts);
this.addEventListener('touchstart',e=>{if(e.target.closest('button,video,iframe')||e.touches.length!==1){this.start=null;return;}this.start={x:e.touches[0].clientX,y:e.touches[0].clientY};},{...opts,passive:true});
this.addEventListener('touchend',e=>{if(!this.start)return;const dx=e.changedTouches[0].clientX-this.start.x,dy=e.changedTouches[0].clientY-this.start.y;this.start=null;if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy)*1.3)this.show(this.index+(dx>0?1:-1));},{...opts,passive:true});
this.addEventListener('touchcancel',()=>{this.start=null;},opts);
const select=this.closest('.ace-product')?.querySelector('select[name="id"]');
if(select){const sync=()=>{const id=select.selectedOptions[0]?.dataset.mediaId;const i=this.slides.findIndex(s=>s.dataset.mediaId===id);if(i>=0)this.show(i);};select.addEventListener('change',sync,opts);sync();}
}
show(index){if(!this.slides.length)return;const next=(index+this.slides.length)%this.slides.length;if(next!==this.index){this.slides[this.index]?.querySelectorAll('video').forEach(v=>v.pause());this.slides[this.index]?.querySelectorAll('iframe').forEach(f=>{const src=f.getAttribute('src');f.setAttribute('src',src);});}this.index=next;this.slides.forEach((slide,i)=>slide.hidden=i!==next);const current=this.querySelector('[data-current]');if(current)current.textContent=String(next+1);}
disconnectedCallback(){this.abort?.abort();this.ready=false;}
});}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ace-reviews"] && !Shopify.designMode) return;
  try {
    
function openAceReviewResult(){document.querySelectorAll('.ar-form-wrap').forEach(function(panel){if(panel.querySelector('.ar-success,.errors')||location.hash==='#'+panel.id){panel.open=true;}});}openAceReviewResult();document.addEventListener('shopify:section:load',openAceReviewResult);window.addEventListener('hashchange',openAceReviewResult);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ace-slideshow"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ace-slideshow')) {
  customElements.define('ace-slideshow', class extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-dot]')];
      if (!this.slides.length) { this.hidden = true; return; }
      this.index = 0; this.paused = matchMedia('(prefers-reduced-motion: reduce)').matches; this.hovered = false;
      this.abort = new AbortController(); const opts = {signal:this.abort.signal};
      this.toggle = this.querySelector('[data-toggle]');
      this.show(0); this.classList.add('as-ready');
      this.querySelector('.as-controls').hidden = this.slides.length < 2;
      this.querySelector('[data-prev]').addEventListener('click',()=>{this.show(this.index-1);this.schedule();},opts);
      this.querySelector('[data-next]').addEventListener('click',()=>{this.show(this.index+1);this.schedule();},opts);
      this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>{this.show(i);this.schedule();},opts));
      this.toggle.addEventListener('click',()=>{this.paused=!this.paused;this.schedule();},opts);
      this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule();},opts);
      this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule();},opts);
      this.addEventListener('focusin',()=>{clearTimeout(this.timer);},opts);
      this.addEventListener('focusout',()=>{setTimeout(()=>this.schedule(),0);},opts);
      this.addEventListener('touchstart',e=>{this.startX=e.touches[0].clientX;}, {...opts,passive:true});
      this.addEventListener('touchend',e=>{const distance=e.changedTouches[0].clientX-this.startX;if(Math.abs(distance)>55){this.show(this.index+(distance>0?1:-1));this.schedule();}}, {...opts,passive:true});
      document.addEventListener('visibilitychange',()=>this.schedule(),opts);
      this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.block===e.detail.blockId);if(i>=0){this.paused=true;this.show(i);this.schedule();}},opts);
      this.schedule();
    }
    show(index) {
      this.index=(index+this.slides.length)%this.slides.length;
      this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('as-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active));});
      this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));
    }
    schedule() {
      clearTimeout(this.timer);if(!this.isConnected)return;
      this.toggle.textContent=this.paused?this.toggle.dataset.play:this.toggle.dataset.pause;
      this.toggle.setAttribute('aria-pressed',String(this.paused));
      if(this.paused||this.hovered||document.hidden||this.contains(document.activeElement)||this.slides.length<2)return;
      this.timer=setTimeout(()=>{this.show(this.index+1);this.schedule();},Number(this.dataset.interval)||6000);
    }
    disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ace-storefront"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ace-carousel'))customElements.define('ace-carousel',class extends HTMLElement{
 connectedCallback(){if(this.cleanup)return;this.slides=[...this.querySelectorAll('.ac-slide')];this.dots=[...this.querySelectorAll('[data-dot]')];this.index=0;this.stopped=false;this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.stopped=this.motion.matches;const ctrl=new AbortController();this.cleanup=()=>{ctrl.abort();clearInterval(this.timer)};const on=(el,event,fn)=>el.addEventListener(event,fn,{signal:ctrl.signal});
 this.show=(n,manual=false)=>{this.index=(n+this.slides.length)%this.slides.length;this.slides.forEach((s,i)=>{s.hidden=i!==this.index;s.inert=i!==this.index});this.dots.forEach((d,i)=>d.setAttribute('aria-current',String(i===this.index)));if(manual)this.querySelector('[data-status]').textContent=this.slides[this.index].getAttribute('aria-label');};
 const pause=this.querySelector('[data-pause]');const label=()=>{pause.textContent=this.stopped?'▶':'Ⅱ';pause.setAttribute('aria-pressed',String(this.stopped));pause.setAttribute('aria-label',this.stopped?'تشغيل الحركة التلقائية':'إيقاف الحركة التلقائية')};label();
 on(this.querySelector('[data-next]'),'click',()=>this.show(this.index+1,true));on(this.querySelector('[data-prev]'),'click',()=>this.show(this.index-1,true));this.dots.forEach((d,i)=>on(d,'click',()=>this.show(i,true)));on(pause,'click',()=>{this.stopped=!this.stopped;label()});on(this.motion,'change',()=>{this.stopped=this.motion.matches;label()});on(this,'keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.show(this.index+(e.key==='ArrowLeft'?1:-1),true)}});
 on(this,'pointerenter',()=>this.hover=true);on(this,'pointerleave',()=>this.hover=false);on(this,'touchstart',e=>{this.touch=[e.touches[0].clientX,e.touches[0].clientY]});on(this,'touchend',e=>{if(!this.touch)return;const dx=e.changedTouches[0].clientX-this.touch[0],dy=e.changedTouches[0].clientY-this.touch[1];if(Math.abs(dx)>45&&Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx>0?1:-1),true);this.touch=null});
 this.timer=setInterval(()=>{if(!this.stopped&&!this.hover&&!document.hidden&&!this.contains(document.activeElement)){const r=this.getBoundingClientRect();if(r.bottom>0&&r.top<innerHeight)this.show(this.index+1)}},6000);
 }
 disconnectedCallback(){this.cleanup?.();this.cleanup=null}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
